export const GET_LIST_RANKS_WATCHER =
  "app/ReportsV2/WidgetAnalysisSegment/GET_LIST_RANKS_WATCHER"
export const GET_LIST_RANKS_SUCCESS =
  "app/ReportsV2/WidgetAnalysisSegment/GET_LIST_RANKS_SUCCESS"
export const GET_LIST_RANKS_FAILED =
  "app/ReportsV2/WidgetAnalysisSegment/GET_LIST_RANKS_FAILED"
